import { useEffect } from 'react'
import { useSharedValue, withSpring } from 'react-native-reanimated'
import { Control, FieldValues, Path } from 'react-hook-form'
import { ModalBottom } from '@ui/components/Modal'

import { inputsOrder, SelectedKey, SelectedKeySetter } from './types'
import PickerBody from './PickerBody'
import { springConfig } from './styles'
import { RefractionForm } from '@ca/common'
import { View } from 'react-native'
import Button from '@ui/buttons/Button'
import { useTranslation } from 'react-i18next'
import { usePrescriptionLabel } from 'hooks/useAttributeLabel'

interface Props<T extends FieldValues> {
  control: Control<T>
  selected: SelectedKey<T>
  setSelected: SelectedKeySetter<T>
}

export default function PickerModal<T extends FieldValues>(props: Props<T>) {
  const { control, selected, setSelected } = props
  const { t } = useTranslation(['ui'])
  const open = !!selected
  const isOpen = open ? 1 : 0
  const active = useSharedValue(isOpen)

  const close = () => {
    active.set(withSpring(isOpen, springConfig))
    setSelected(null)
  }

  // TODO: types here could be improved
  const index = inputsOrder.indexOf(selected as Path<RefractionForm>)
  const prevValue =
    index > 0 ? inputsOrder[index - 1] : inputsOrder[inputsOrder.length - 1]
  const nextValue =
    index < inputsOrder.length - 1 ? inputsOrder[index + 1] : inputsOrder[0]

  const onPrevValue = () => setSelected(prevValue as SelectedKey<T>)
  const onNextValue = () => setSelected(nextValue as SelectedKey<T>)

  const prevLabel = usePrescriptionLabel(prevValue)
  const nextLabel = usePrescriptionLabel(nextValue)

  useEffect(() => {
    active.set(withSpring(isOpen, springConfig))
  }, [isOpen])

  return (
    <ModalBottom
      open={open}
      close={close}
      center
      disableScroll
      hideBottomSpace
      // intensity={0}
      // modalProps={{
      //   backdropContent: (
      //     <Animated.View
      //       className="pointer-events-none fixed left-0 top-0 h-full w-full bg-black/50"
      //       style={styleBackground}
      //     />
      //   ),
      // }}
    >
      {open && <PickerBody key={selected} name={selected} control={control} />}
      {inputsOrder.includes(selected as Path<RefractionForm>) && (
        <View className="flex w-full flex-row items-center justify-between px-16 pb-12">
          <Button
            variant="outlined"
            label={prevLabel}
            iconStart="arrow-left"
            onPress={onPrevValue}
          />
          <Button
            variant="outlined"
            label={nextLabel}
            iconEnd="arrow-right"
            onPress={onNextValue}
          />
        </View>
      )}
    </ModalBottom>
  )
}
